<template>
    <el-form ref="form">
        <el-collapse  v-if="$p('settings/status/gauges')"  accordion>
            <el-collapse-item title="Status">
                <el-row justify="space-between" :gutter="25">
                    <el-col :lg="8" :md="12" :sm="8" :xs="24">
                        <el-card class="box-card">
                            <div slot="header" class="headers">
                                <span> <strong> {{$l('settings/status/SDD')}} </strong> </span>
                            </div>
                            <el-progress type="circle" :percentage="getSystemStatus.hdd_percent"></el-progress>
                            <div class="statusCharts"> <strong> {{$l('settings/status/total')}}: </strong> {{getSystemStatus.hdd_total}} GB</div>
                            <div class="statusCharts"> <strong> {{$l('settings/status/free')}}: </strong> {{getSystemStatus.hdd_free}} GB</div>
                            <div class="statusCharts"> <strong> {{$l('settings/status/used')}}: </strong> {{getSystemStatus.hdd_used}} GB</div>
                        </el-card>
                    </el-col>
                    <el-col :lg="8" :md="12" :sm="8" :xs="24">
                        <el-card class="box-card">
                            <div slot="header" class="headers">
                                <span> <strong> {{$l('settings/status/memory')}} </strong></span>
                            </div>
                            <el-progress type="circle" :percentage="getSystemStatus.mem_percent"></el-progress>
                            <div class="statusCharts"> <strong> {{$l('settings/status/total')}}: </strong> {{getSystemStatus.mem_total}} GB</div>
                            <div class="statusCharts"> <strong> {{$l('settings/status/free')}}: </strong> {{getSystemStatus.mem_free}} GB</div>
                            <div class="statusCharts"> <strong> {{$l('settings/status/used')}}: </strong> {{getSystemStatus.mem_used}} GB</div>
                        </el-card>
                    </el-col>
                    <el-col :lg="8" :md="12" :sm="8" :xs="24">
                        <el-card class="box-card">
                            <div slot="header" class="headers">
                                <span> <strong> {{$l('settings/status/camera')}}</strong></span>
                            </div>
                            <el-progress type="circle" :percentage="getSystemStatus.cam_sd_percent"></el-progress>
                            <div class="statusCharts"> <strong> {{$l('settings/status/total')}}: </strong> {{getSystemStatus.cam_sd_size}} GB</div>
                            <div class="statusCharts"> <strong> {{$l('settings/status/free')}}: </strong> {{getSystemStatus.cam_sd_free}} GB</div>
                            <div class="statusCharts"> <strong> {{$l('settings/status/used')}}: </strong> {{getSystemStatus.cam_sd_used}} GB</div>
                        </el-card>
                    </el-col>
                    <el-col :lg="8" :md="12" :sm="8" :xs="24">
                        <el-card class="box-card-unique">
                            <div slot="header" class="headers">
                                <span> <strong> {{$l('settings/status/n140')}} </strong> </span>
                            </div>
                            <el-progress type="circle" :percentage="getSystemStatus.n140_sd_percent"></el-progress>
                            <div class="statusCharts"> <strong> {{$l('settings/status/total')}}: </strong> {{$l('settings/status/gbOrMore')}}</div>
                            <div class="statusCharts"> <strong> {{$l('settings/status/free')}}: </strong> {{Math.round((100-getSystemStatus.n140_sd_percent)*10)/10}}% {{$l('settings/status/of')}} 2GB</div>
                            <div class="statusCharts"> <strong> {{$l('settings/status/used')}}: </strong> {{Math.round((getSystemStatus.n140_sd_percent)*10)/10}}% {{$l('settings/status/of')}} 2GB</div>
                        </el-card>
                    </el-col>
                    <el-col :lg="8" :md="12" :sm="8" :xs="24">
                        <el-card class="box-card-unique">
                            <div slot="header" class="headers">
                                <span> <strong> {{$l('settings/status/cpu')}} </strong> </span>
                            </div>
                            <el-progress type="circle" :percentage="getSystemStatus.cpu_percent"></el-progress>
                        </el-card>
                    </el-col>
                </el-row>
            </el-collapse-item>
        </el-collapse>
        <el-row style="margin-top:10px; margin-bottom:10px;" :gutter="25">
            <el-col :lg="8">
                <el-card> 
                    <div slot="header" class="headers">
                        <span><strong>{{$l('settings/status/firmware')}}</strong></span>
                    </div>
                        <el-row :gutter="25">
                            <el-col>
                                <el-form-item class="el-form-item-full" :label="$l('settings/status/Version') + ' :'">
                                    <el-input disabled v-model="getFirmware.version"> </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col>
                                <el-form-item class="el-form-item-full" :label="$l('settings/status/Release') + ' :'">
                                    <el-input disabled v-model="getFirmware.release"> </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col>
                                <el-form-item class="el-form-item-full" :label="$l('settings/status/PCFree') + ' :'">
                                    <el-input disabled v-model="getSettingsSystem.pchddlimit"> </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                </el-card>
            </el-col>
            <el-col :lg="16" v-if="$p('settings/status/logs')">
                <el-card  v-show="getSettingsAddons.logs == '1'"> 
                    <div slot="header" class="headers">
                        <span><strong>{{$l('settings/status/logs')}}</strong></span>
                    </div>
                        <el-row :gutter="20">
                            <el-col :sm="24" :lg="19">
                                <el-select v-model="selectedLog" :placeholder="$l('common/select')">
                                    <el-option
                                        v-for="item in logTypes"
                                        :key="item"
                                        :label="item"
                                        :value="item">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :sm="24" :lg="5">
                                <el-button @click="downloadClicked" :disabled="!selectedLog" style="width:100%">{{$l('settings/status/download')}}</el-button>
                            </el-col>
                        </el-row>
                        <el-row v-loading="logsLoading" class="logsCard" :gutter="25">
                            <div v-for="(item, i) in logs" v-bind:key="i">{{item}}</div>
                        </el-row>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="25" v-if="$p('settings/status/users')">
            <div class="users-title">{{$l('settings/status/users')}}</div>
            
            <el-col :md="8">
                <el-card v-if="$p('settings/status/userAdmin')" >
                    <div slot="header" class="headers">
                        <span><strong>{{$l('settings/status/adminUsr')}}</strong></span>
                    </div>
                    <el-form>
                        <el-form-item :label="$l('settings/status/username')">
                            <el-input v-model="getSettingsUsers.userAdmin"></el-input>
                        </el-form-item>
                        <el-form-item class="el-form-item-full"  :label="$l('settings/FTPSending/Password')">
                            <el-input :type="showPassword.admin?'':'password'" v-model="getSettingsUsers.pwdAdmin">
                                <el-button @click="showPassword.admin=!showPassword.admin" class="show-password-button" slot="append"><icon class="show-password-icon" name="eye"> </icon></el-button>
                            </el-input>
                        </el-form-item>
                    </el-form>
                </el-card>
            </el-col>
            <el-col :md="8">
                <el-card v-if="$p('settings/status/userOper')">
                    <div slot="header" class="headers">
                        <span><strong>{{$l('settings/status/noiseUsr')}}</strong></span>
                    </div>
                     <el-form>
                        <el-form-item :label="$l('settings/status/username')">
                            <el-input v-model="getSettingsUsers.userNoise"></el-input>
                        </el-form-item>
                        <el-form-item class="el-form-item-full"  :label="$l('settings/FTPSending/Password')">
                            <el-input :type="showPassword.user?'':'password'" v-model="getSettingsUsers.pwdNoise">
                                <el-button @click="showPassword.user=!showPassword.user" class="show-password-button" slot="append"><icon class="show-password-icon" name="eye"> </icon></el-button>
                            </el-input>
                        </el-form-item>
                    </el-form>
                </el-card>
            </el-col>
            <el-col :md="8">
                <el-card v-if="$p('settings/status/userGuest')">
                    <div slot="header" class="headers">
                        <span><strong>{{$l('settings/status/guestUsr')}}</strong></span>
                    </div>
                     <el-form>
                        <el-form-item :label="$l('settings/status/username')">
                            <el-input v-model="getSettingsUsers.userGuest"></el-input>
                        </el-form-item>
                        <el-form-item class="el-form-item-full"  :label="$l('settings/FTPSending/Password')">
                            <el-input :type="showPassword.guest?'':'password'" v-model="getSettingsUsers.pwdGuest">
                                <el-button @click="showPassword.guest=!showPassword.guest" class="show-password-button" slot="append"><icon class="show-password-icon" name="eye"> </icon></el-button>
                            </el-input>
                        </el-form-item>
                    </el-form>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="25" style="margin-top:10px">
            <el-col>
                <el-form-item class="el-form-item-full">
                    <el-button :loading="rebootLoading" @click="rebootSystemMessage()">{{$l('settings/status/Reboot')}}</el-button>
                </el-form-item>
            </el-col>
        </el-row>
    </el-form>
    
</template>

<style scoped>
.show-password-icon{
    min-width: 16px;
}
.el-progress-circle{ /* Doesn't work */
    height:100px;
    width:100px;
}
.headers{
    text-align:center;
    line-height:1px;
}
.logsCard{
    min-height: 246px;
    max-height:246px;
    overflow: scroll;
    padding-left: 15px;
    padding-right: 15px;
    margin-top: 10px;
    margin-bottom: -10px;
}
.box-card-status{
    margin-top:10px;
    height:100%;
}
.box-card-unique{
    margin-top:10px;
    text-align:center;
    height:100%;
}
.box-card{
    margin-top:10px;
    text-align:center;
}
.statusCharts{
    text-align: center;
    padding:4px;
}
.statusSettings{
    text-align: left;
    padding:4px;
}
.users-title{
    margin-left: 15px;
    font-size: 20px;
    margin-top: 5px;
    margin-bottom: 5px;
}
</style>

<script>
import {logsList,getLogs,rebootSys} from '@/store/actions';
import {mapGetters} from 'vuex'
export default {
    data() {
        return {
            rebootLoading: false,
            logTypes:[],
            selectedLog:'',
            logs:[],
            logsLoading:false,
            showPassword:{
                admin: false,
                user: false,
                guest: false
            }
        }
    },
    computed:{
        ...mapGetters([
            'getSystemStatus',
            'getFirmware',
            'getSettingsSystem',
            'getSettingsUsers',
            'getSettingsAddons',
        ])
    },
    methods: {
        onSubmit() {
            console.log('submit!');
        },
        rebootSystemMessage(){
            this.$confirm(this.$l('settings/status/Reboot confirm'), this.$l('settings/warning'),{
                confirmButtonText: this.$l('settings/continue'),
                cancelButtonText: this.$l('settings/cancel'),
                type: 'Warning'
            }).then(() =>{
                this.rebootLoading = true;
                setTimeout(()=>{
                    this.$message({
                        type: 'success',
                        message: this.$l('settings/status/Reboot success')
                    });
                    rebootSys(this.$store);
                    this.rebootLoading = false;                    
                },1500)
                
            }).catch(()=>{
                this.$message({
                    type:'info',
                    message: this.$l('settings/status/Reboot cancel')
                })
            })
        },
        downloadClicked(){

            //window.location = '/api/logs-download&file='+this.selectedLog;
            this.setDownloading({enabled: true, progress: 0, preparing:true})
                api.getFileAction('/api/logs-download&file='+this.selectedLog+'&time='+Date.now(),'GET','', (progress)=>{
                    let percentage = Math.round((progress.loaded/progress.total)*100);
                    this.setDownloadingProgress(percentage);
                })
                .then(()=>{
                    this.setDownloading({enabled: false, progress: 0})
                })
                .catch(()=>{
                    this.setDownloading({enabled: false, progress: 0})
                    
                })
        }
    },
    watch:{
        selectedLog: function(newLog){
            this.logsLoading = true;
            getLogs(this.$store,newLog)
                .then(data=>{
                    this.logs = data.split('\n').reverse();
                    this.logsLoading = false;
                    
                })
        }
    },
    mounted: function(){
        logsList(this.$store)
            .then(logs=>{
                this.logTypes = logs;
            })
    }
}
</script>


// WEBPACK FOOTER //
// Status.vue?2c4f01af